import Vue from "vue";
import Vuex from "vuex";

/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading vuex modules
 * -----------------------------------------------------------------------------------------------------------
 */
import account from "@/views/account/store";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    path: "",
    full_path: "",
    socket_connect: true,
    total_unseen_message: 0,
  },
  getters: {
    path: (state) => state.path,
    full_path: (state) => state.full_path,
    socket_connect: (state) => state.socket_connect,
    total_unseen_message: (state) => state.total_unseen_message,
  },
  mutations: {
    setPath(state, path) {
      state.path = path;
    },
    setFullPath(state, full_path) {
      state.full_path = full_path;
    },
    setSocketConect(state, socket_connect) {
      state.socket_connect = socket_connect;
    },
    setTotalUnseenMessage(state, total_unseen_message) {
      state.total_unseen_message = total_unseen_message;
    },
  },
  actions: {
    setPath({ commit }, path) {
      commit("setPath", path);
    },
    setFullPath({ commit }, full_path) {
      commit("setFullPath", full_path);
    },
    setSocketConect({ commit }, socket_connect) {
      commit("setSocketConect", socket_connect);
    },
    setTotalUnseenMessage({ commit }, total_unseen_message) {
      commit("setTotalUnseenMessage", total_unseen_message);
    },
  },
  modules: {
    account,
  },
});
